import React from "react";
import { CustomCode as CustomCodeBase } from "repoV2/components/customCode/CustomCode";
import { useGetCustomCodes } from "./CustomCode.helpers";

export { CustomCodeBase };

export const CustomCode = ({ position }: { position: number }) => {
    const codes = useGetCustomCodes();
    return <CustomCodeBase position={position} codes={codes} />;
};

/**
 * NOTE:
 * - not sure why, but calling this with component syntax inside HEAD does not make it appear in the DOM.
 * - child components should be called as a function as well
. */

export const CustomCodeForHead = ({ position }: { position: number }) => {
    const codes = useGetCustomCodes();
    return CustomCodeBase({ position, codes });
};
